require('./bootstrap');

flatpickr(".datepicker", {dateFormat: "Y-m-d"});
flatpickr(".datetimepicker", {enableTime: true, dateFormat: "Y-m-d H:i", time_24hr: true});
flatpickr(".timepicker", {enableTime: true, noCalendar: true, dateFormat: "H:i", time_24hr: true});

$('#mainModal').on('shown.bs.modal',function(event){
    var url = $(event.relatedTarget).data('url');
    if(url)
        $(this).find('iframe').attr('src', url);
})

$('a[data-action="delete"]').on('click', function(event){
    event.preventDefault();
    if(confirm('Continue ?')){
        var form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', this.href);
        form.setAttribute('class', 'd-none');

        var csrf = document.createElement('input');
        csrf.setAttribute('type', 'hidden');
        csrf.setAttribute('name', '_token');
        csrf.value = $(this).data('csrf');

        var method = document.createElement('input');
        method.setAttribute('type', 'hidden');
        method.setAttribute('name', '_method');
        method.value = 'DELETE';

        form.appendChild(csrf);
        form.appendChild(method);
        document.body.appendChild(form);
        form.submit();
    }

});

// $('.createparticipants input[name="type_id"]').on('click', function(event){
//     var max_participant = $(this).data('max-participant');
//     if(max_participant){
//         $('form.createparticipants .participant').hide();
//         for (let index = 1; index <= max_participant; index++) {
//             $('form.createparticipants .participant_'+index).show();
//         }
//     }
// });

var options = {
    chart: {
      type: 'line'
    },
    series: [{
      name: 'sales',
      data: [30,40,35,50,49,60,70,91,125]
    }],
    xaxis: {
      categories: [1991,1992,1993,1994,1995,1996,1997, 1998,1999]
    }
  }

  function chart_bar(element, data, categories){
    (new ApexCharts(
        element,
        {
            series: [{
            data: data
          }],
            chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: categories,
          }
          }
        )
    ).render();
  }

  $('[data-chart="true"]').on('click', function(event){
    event.preventDefault();
    if(confirm('Continue ?')){
        var form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', this.href);
        form.setAttribute('class', 'd-none');

        var csrf = document.createElement('input');
        csrf.setAttribute('type', 'hidden');
        csrf.setAttribute('name', '_token');
        csrf.value = $(this).data('csrf');

        var method = document.createElement('input');
        method.setAttribute('type', 'hidden');
        method.setAttribute('name', '_method');
        method.value = 'DELETE';

        form.appendChild(csrf);
        form.appendChild(method);
        document.body.appendChild(form);
        form.submit();
    }

});

$( '[data-chart="true"]' ).each(function(){
    if($(this).data('type') && $(this).data('data') && $(this).data('categories')){
        let data = $(this).data('data');
        if(typeof $(this).data('data') == 'string')
            data = eval($(this).data('data'))

        let categories = $(this).data('categories')
        if(typeof $(this).data('categories') == 'string')
            categories = eval($(this).data('categories'))
        console.log(data)
        console.log(categories)
        if($(this).data('type') == 'bar'){
            chart_bar(this, data, categories)
        }
    }
});

